import React from 'react';
import { Container } from "react-bootstrap";
const Footer = () => {
    return (
      <Container fluid className="footer">
      <p><span> Copyright ©  {new Date().getFullYear() } RHYM TECHNOLOGIES LLP | All rights reserved </span></p>
    </Container>

    );
  };
  export default Footer